import { Role } from '@prisma/client';

export const availableRoles = [Role.ADMIN, Role.USER, Role.VIEWER, Role.GUEST];
